import { isSuccessStatus } from '@utils/statusSuccess'
import {
  SignUpSendTokenRequestBodySignUpTypeEnum,
  SignUpConfirmTokenRequestBody,
} from '../swagger'
import { auth } from './swagger'

export const sendTokenForSignup = async (payload: {
  email: string
  signUpType: SignUpSendTokenRequestBodySignUpTypeEnum
  agreementId: string
}): Promise<boolean | undefined> => {
  await auth.sendTokenForSignup({
    body: {
      username: payload.email,
      signUpType: payload.signUpType,
      typeIdentifier: payload.agreementId,
    },
  })
  return true
}

export const confirmTokenForSignup = async (
  payload: SignUpConfirmTokenRequestBody
): Promise<boolean> => {
  try {
    const response = await auth.confirmTokenForSignupRaw({ body: payload })

    return isSuccessStatus(response.raw.status)
  } catch (error) {
    console.error('Login failed:', error)

    throw error
  }
}

export default confirmTokenForSignup
